import { observer } from "mobx-react-lite";
import { Col, Row, Select } from "antd";
import { useStore } from "../../stores/root-store-context";
import { NewGroupModal } from "./NewGroupModal";

export const SelectGroup = observer(() => {
  const { applicationStore, membersStore } = useStore();

  const onChangeGroup = (id: string): void => {
    if (id === "addNewGroup") {
      applicationStore.showAddGroupModal();
    } else {
      const item = applicationStore.groupList.find(
        (el) => el.id.toString() === id.toString()
      );
      applicationStore
        .changeGroup(item)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });
      if (applicationStore.comiteeId) {
        membersStore
          .loadMembers(applicationStore.comiteeId.toString())
          .catch(console.log);
      }
    }
  };

  return (
    <>
      <div className="mat__search-row">
        <div className="mat__search-col" style={{ maxWidth: "20rem" }}>
          <b>Group</b>
        </div>
        <div className="mat__search-col" style={{ maxWidth: "20rem" }}>
          <Select
            data-testid="mat-select-group"
            disabled={
              applicationStore.isLoadGroups ||
              !applicationStore.selectedPropertyId
            }
            showSearch
            value={applicationStore.comiteeName}
            style={{ width: "100%" }}
            onChange={onChangeGroup}
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input.toLocaleLowerCase()
              )
            }
            options={
              !applicationStore.isFinCen
                ? [
                    ...applicationStore.groupList.map((el, index) => {
                      return { key: index, value: el.id, label: `${el.name}` };
                    }),
                    {
                      key: "addNewGroup",
                      value: "addNewGroup",
                      label: "+ Add new group...",
                    },
                  ]
                : [
                    ...applicationStore.groupList.map((el, index) => {
                      return { key: index, value: el.id, label: `${el.name}` };
                    }),
                  ]
            }
          />
        </div>
      </div>
      {applicationStore.isShowVerbiage && (
        <div style={{ color: "#1a73e8", fontSize: 12, marginTop: 4 }}>
          <strong>
          Please notify your Admin of any changes made so they may<br />
          update your ARC instructions.
          </strong>
        </div>
      )}
      <NewGroupModal
        isOpenModal={applicationStore.showAddCommiteeGroupModal}
        dismissModal={() => {
          applicationStore.hideAddGroupModal();
        }}
        onSave={() => {
          applicationStore
            .saveGroupModal()
            .then(() => {
              applicationStore.hideAddGroupModal();
              setTimeout(() => {
                if (applicationStore.comiteeId) {
                  membersStore
                    .loadMembers(applicationStore.comiteeId.toString())
                    .catch(console.log);
                }
              }, 1000);
            })
            .catch(console.error);
        }}
      />
    </>
  );
});